import enMessages from "../locales/en.json";
import esMessages from "../locales/es.json";
import frMessages from "../locales/fr.json";
import itMessages from "../locales/it.json";

export const LOCALES = ["en", "fr", "es", "it"];
export const DEFAULT_LOCALE = "en";

const messages: { [key: string]: Record<string, string> } = {
  en: enMessages,
  es: esMessages,
  fr: frMessages,
  it: itMessages,
};
export const getMessages = (locale: string): Record<string, string> => {
  return locale === DEFAULT_LOCALE
    ? messages[locale]
    : { ...messages[DEFAULT_LOCALE], ...messages[locale] };
};
